import { Box as Container, Paper, Stack } from '@mui/material'
import Label from 'components/Label'
import { StepIndex } from 'pages/CreateHearing/enums/step.enum'
import React from 'react'
import { StyledBoxTitle as BoxTitle } from './styles'

type StepContentProps = {
  title?: string
  currentStep: number
  children: React.ReactNode
}

const StepContent: React.FC<StepContentProps> = ({ title, currentStep, children }) => (
  <Paper elevation={0} sx={{ p: 4 }}>
    <BoxTitle>
      <Label text={title} v='h5' bold />
    </BoxTitle>

    {currentStep !== StepIndex.RESUMO_OITIVA && (
      <Stack direction='row' pb={4}>
        <Label text='Campos Obrigatórios' v='body2' bold />
        <Label text='*' v='body2' sx={{ color: 'error.main', marginLeft: 1 }} bold />
      </Stack>
    )}

    <Container>{children}</Container>
  </Paper>
)

export default StepContent
